import { ITrialClass } from '@wot/typings';
import xhr from '../utils/fetch';

const getClasses = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: ITrialClass[] }> => {
  const res = await xhr({
    url: `/a/classes`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  });
  if (res.status === 'OK') {
    return res.data;
  } else {
    throw Error(res.message);
  }
};

const getClassesDisputes = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: ITrialClass[] }> => {
  const res = await xhr({
    url: `/a/classes/disputes`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  });
  if (res.status === 'OK') {
    return res.data;
  } else {
    throw Error(res.message);
  }
};

const getFacetsByCategoryName = async () => {
  return await xhr({
    url: '/a/classes/facets/categoryName',
    method: "GET"
  }).then((res) => res.data)
    .catch(err => { throw err });
}

const classesApi = {
  getClasses,
  getClassesDisputes,
  getFacetsByCategoryName
};

export default classesApi;
